import $ from "jquery";
import selectize from "selectize";
var Isotope = require("isotope-layout");

document.addEventListener("DOMContentLoaded", function () {
   // find element with data-isotope;
   const isotopeContent = document.querySelector(".js-isotope");
   if (isotopeContent !== null) {
      const selector = isotopeContent.dataset.selector;
      const wrapper = document.querySelector(isotopeContent.dataset.wrapper);
      //contentSearchInput = document.querySelector(isotopeContent.dataset.searchInput)
      initIsotope(selector, wrapper);
      // read url
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const category = urlParams.get("cat");
      if (category !== null) {
         buttonFilter = category;
         $iso.arrange(opts);
      }
   }
});

let gridFilterButtons = document.querySelectorAll(".js-sort-article");
let buttonFilter;
let $iso = null;
let opts = {
   itemSelector: ".article-card",
   resize: false,
   transitionDuration: "none",
   layoutMode: "no-shuffle",
   hiddenStyle: {
      opacity: 0,
   },
   visibleStyle: {
      opacity: 1,
   },
   filter: (card) => {
      let buttonResult = buttonFilter ? card.matches(buttonFilter) : true;
      return buttonResult;
   },
};

const pushFilterToUrl = (val) => {
   window.history.replaceState({}, "", `?cat=${val}`);
};

const clearIsActiveButtons = () => {
   gridFilterButtons.forEach((filterButton) => {
      filterButton.classList.remove("is-active");
   });
};

// layout mode that does not position items
Isotope.LayoutMode.create("no-shuffle");

function debounce(fn, threshold) {
   var timeout;
   threshold = threshold || 100;
   return function debounced() {
      clearTimeout(timeout);
      var args = arguments;
      var _this = this;
      function delayed() {
         fn.apply(_this, args);
      }
      timeout = setTimeout(delayed, threshold);
   };
}

Isotope.LayoutMode.create("no-shuffle");

Isotope.prototype.arrange = function () {
   // set any options pass
   this.option(opts);
   this._getIsInstant();
   // just filter
   this.filteredItems = this._filter(this.items);

   this.filteredItems.needHide.forEach((item) => {
      item.element.classList.add("is-hidden");
   });
   this.filteredItems.matches.forEach((item) => {
      item.element.classList.remove("is-hidden");
   });
   // flag for initalized
   this._isLayoutInited = true;
};

if (gridFilterButtons !== null) {
   gridFilterButtons.forEach((filterButton) => {
      filterButton.classList.remove("is-active");
      filterButton.addEventListener("click", () => {
         clearIsActiveButtons();
         buttonFilter = filterButton.dataset.category;
         if (buttonFilter == "*") {
            pushFilterToUrl(buttonFilter);
            $iso.arrange(opts);
         } else {
            pushFilterToUrl(buttonFilter);
            filterButton.classList.add("is-active");
            $iso.arrange(opts);
            console.log();
         }
      });
   });
}

const clearFilters = () => {
   buttonFilter = null;
   $iso.arrange(opts);
};

const initIsotope = (s, w) => {
   if (w !== null) {
      $iso = new Isotope(w, {
         layoutMode: "no-shuffle",
         ...opts,
      });
   }
};

$(document).ready(function () {
   let storeSelector = $(".js-store-selector").selectize({
      create: false,
      allowEmptyOption: true,
      //sortField: "text",
   });

   storeSelector.on("change", (e) => {
      let url = storeSelector[0].value;
      if (url !== undefined || url !== null) window.location.href = url;
   });

   // sortering av artikler på historier malen

   let articleSortSelector = $(".js-article-sort").selectize({
      create: false,
      allowEmptyOption: true,
      copyClassesToDropdown: true,
   });

   articleSortSelector.on("change", (e) => {
      let option = articleSortSelector[0].value;
      buttonFilter = `${option}`;
      pushFilterToUrl(buttonFilter);
      $iso.arrange(opts);
   });

   // for the contact us template

   let storeSelectorContact = $(".js-store-selector-contact").selectize({
      create: false,
      allowEmptyOption: true,
      render: {
         item: function (data, escape) {
            return `<div data-title="${data.title}" data-phone="${data.phone}" data-address="${data.address}" data-url="${data.url}">${data.text}</div>`;
         },
      },
   });

   $(storeSelectorContact).each(function (index, value) {
      let el = $(value);
      let total = $(storeSelectorContact).length;
      el.on("change", (e) => {
         if (
            index == 0 &&
            document.querySelector(".js-store-information") !== null &&
            total > 1
         ) {
            var selectizeOrg = $(storeSelectorContact)[0].selectize;
            let val = selectizeOrg.getValue();
            var selectize = $(storeSelectorContact)[1].selectize; // This stores the selectize object to a variable (with name 'selectize')
            selectize.setValue(val, false);
         }

         let chooseStore = document.querySelector(".js-choose-store");
         if (chooseStore !== null) {
            chooseStore.classList.add("d-none");
         }

         let store = document.querySelectorAll(
            ".js-store-selector-contact .selectize-input > div"
         );
         store = store[0];
         let storeInformationTarget = $(el).data("target");
         const { title, phone, address, url } = store.dataset;
         let storeInformation = document.querySelector(storeInformationTarget);
         if (title == "undefined") {
            storeInformation.classList.add("d-none");
         } else {
            // update data
            if (storeInformation.classList.contains("d-none")) {
               storeInformation.classList.remove("d-none");
            }
            updateStoreData(storeInformationTarget, title, phone, address, url);
         }
      });
   });
});

const setInnerText = (target, value) => {
   let el = document.querySelector(target);
   if (el !== null) {
      el.innerText = value;
   }
};

const updateStoreData = (target, title, phone, address, url) => {
   setInnerText(target + " .js-store-data-title", title);
   setInnerText(target + " .js-store-data-address", address);
   setInnerText(target + " .js-store-data-phone", phone);
   let urlStorage = document.querySelector(target + " .js-store-data-url");
   if (urlStorage !== null) {
      urlStorage.href = url;
   }
};
